export const countArticleReadingTime = (articleBody: [], arrayOfSymbols: number[] = []) => {
  articleBody.forEach(({ children }: any) => {
    children?.map(({ text }: any) => arrayOfSymbols.push(text.length));
  });
};
